import Error from '../model/Error';
import axios from 'axios';

export default class LetterDraftSendersRepository {
    static findAll(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/drafts/available-senders`)
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
